export default __webpack_public_path__ + "static/media/SigmaStudio.f40089097068cd4c757f3be46bce70e7.webp";